import type { CollectionCodeDataItem, JavascriptSerializable, JavascriptSerialized } from '#layers/data-model/types/javascript-serializable';
import { isTemporal } from '#layers/base/public';
import { serializeTemporalValue } from './schema/serialize-temporal-value';

export function toJavascriptSerializable<T>(value: T): JavascriptSerialized<T>;
export function toJavascriptSerializable(value: unknown): JavascriptSerializable {
	if (Array.isArray(value)) return value.map((item) => toJavascriptSerializable(item));
	if (isTemporal(value)) return serializeTemporalValue(value);

	if (value && typeof value === 'object') {
		return Object.fromEntries(
			Object.entries(value).map(([key, nestedValue]) => [key, toJavascriptSerializable(nestedValue)]),
		) as CollectionCodeDataItem;
	}

	if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || value === null || value === undefined) return value;
	return String(value);
}
